import {
    ItemBag,
    ItemBlocks,
    ItemBox,
    ItemBoxes,
    ItemCalendar,
    ItemGift,
    ItemMoney,
    ItemStopwatch,
} from './assets/images';

import { colors } from './styles/variables';

import {
    heroRef,
    howItWorksRef,
    benefitsRef,
    faqRef,
    opinionsRef,
    contactRef,
} from './utils/sectionRefs';

export const START_HERO_CONFIG = {
    title: "Acordă-ți timp, plătește mai târziu",
    id: "section-hero",
    forwardedRef: heroRef.forwardedRef,
    navigationRef: heroRef.navigationRef,
    heroGraphic: "clienti",
    promoTextColor: colors.paypoGreen600,
    content: [
        {
            text: 'Cumperi astăzi și plătești abia după primirea comenzii și verificarea produselor, fără a-ți bloca fondurile proprii. Tu decizi cum și când plătești pentru ce cumperi, alegând serviciul PayPo adaptat nevoilor tale.',
        },
    ],
};

export const START_DATA_IN_NUMBERS_CONFIG = {
    numbersData: [
        {
            id: 1,
            prefix: null,
            data: "30",
            suffix: "mii",
            description: "magazine disponibile",
        },
        {
            id: 2,
            prefix: null,
            data: "1,8",
            suffix: "mln",
            description: "clienți activi",
        },
        {
            id: 3,
            prefix: null,
            data: "42",
            suffix: "mii",
            description: "recenzii pozitive",
        },
    ],
};

export const START_ORDERED_ITEMS_CONFIG = {
    title: "Cum funcționează?",
    id: "section-how-it-works",
    forwardedRef: howItWorksRef.forwardedRef,
    navigationRef: howItWorksRef.navigationRef,
    itemList: [
        {
            id: 1,
            title: "PASUL 1",
            text: "Când faci cumpărături online, adaugi produsele în coșul de cumpărături și alegi să plătești prin PayPo.",
        },
        {
            id: 2,
            title: "PASUL 2",
            text: "Completezi datele personale solicitate pentru verificarea informațiilor și transmiterea codului SMS.",
        },
        {
            id: 3,
            title: "PASUL 3",
            text: "PayPo plătește pentru achizițiile tale online din magazin, iar tu vei primi comanda.",
        },
        {
            id: 4,
            title: "PASUL 4",
            text: "Verifici cumpăraturile acasă, iar pentru a achita sumele datorate către PayPo, vei avea 30 de zile de la achiziție. Nu uita, vei plăti doar produsele păstrate.",
        },
    ],
    squares: [
        {
            top: "11rem",
            left: "-19rem",
            size: "21rem",
            bgColor: colors.paypoGreen500,
            rotate: "21.77deg",
        }
    ],
};

export const START_VIDEO_CONTAINER_CONFIG = {
    videoId: "6L5-EKdU-VM",
    squares: [
        {
            top: "6rem",
            left: "7.2rem",
            size: "4.8rem",
            bgColor: colors.fuchsia500,
            rotate: "81.39deg",
            zIndex: 1,
        },
        {
            top: "33rem",
            right: "7.2rem",
            size: "4.8rem",
            bgColor: colors.fuchsia500,
            rotate: "20.46deg",
            zIndex: 1,
        },
        {
            top: "11rem",
            right: "-15.5rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
            zIndex: 1,
        },
    ],
};

export const START_ICON_ITEMS_CONFIG = {
    title: "Beneficii",
    id: "section-benefits",
    forwardedRef: benefitsRef.forwardedRef,
    navigationRef: benefitsRef.navigationRef,
    content: [
        {
            Icon: ItemCalendar,
            description: "Ai la dispoziție 30 de zile pentru plată - <strong>fără costuri suplimentare</strong>",
        },
        {
            Icon: ItemBlocks,
            description: "<strong>Verifică comanda acasă</strong> - produsele pe care nu le dorești, le poți returna către magazin, iar la final vei achita doar produsele păstrate.",
        },
        {
            Icon: ItemBoxes,
            description: "Dacă decizi să returnezi produsele, <strong>nu îți vei bloca fondurile proprii</strong>",
        },
        {
            Icon: ItemGift,
            description: "<strong>Îți poți permite mai mult</strong> - fă-ți un cadou ție sau celor dragi și profită de reducerile curente",
        },
        {
            Icon: ItemBag,
            description: "Cumperi în siguranță  - <strong>plătești doar după ce ai decis ce produse vei păstra</strong>",
        },
        {
            Icon: ItemBox,
            description: "Plata prin PayPo este <strong>mai eficientă și mai avantajosă decât plata ramburs la livrare</strong>",
        },
        {
            Icon: ItemMoney,
            description: "Cu timpul îți vei permite mai mult - <strong>Limita pentru achizițiile viitoare poate crește</strong>",
        },
        {
            Icon: ItemStopwatch,
            description: "<b>Plăți instantanee și securizate</b> - tranzacțiile viitoare vor fi confirmate doar cu un cod SMS",
        },
    ],
    additionalText: [
        {
            text: 'Serviciul este disponibil pentru clienții noi PayPo. Informațiile nu constituie o ofertă. Mai multe detalii pot fi găsite în Termenii si conditiile serviciului "PayPo - cumpără acum, plătește în 30 de zile" pe site-ul <a href="https://www.paypo.ro">www.paypo.ro</a>',
        },
    ],
};

export const START_ACCORDION_SECTION = {
    title: "Cele mai des adresate întrebări",
    id: "section-faq",
    forwardedRef: faqRef.forwardedRef,
    navigationRef: faqRef.navigationRef,
    content: [
        {
            id: "1",
            title: "1. Va trebui să furnizez detaliile cardului meu de credit/debit?",
            text: "Nu. Pentru a utiliza serviciile PayPo, este suficient completarea datelor solicitate în formularul de finalizare a comenzii. Toate informațiile cu privire la comanda ta vor fi trimise la adresa de e-mail furnizată la finalizarea comenzii.",
            isExpanded: true,
        },
        {
            id: "2",
            title: "2. Cum pot plăti comanda mea?",
            text: "Poți efectua plata prin transfer bancar. Toate informațiile cu privire la tremenul de plată, valoarea comenzii, numărul contului bancar precum și confirmarea comenzii vor fi trimise pe email la adresa furnizată în procesul de finalizare a comenzii.",
        },
        {
            id: "3",
            title: "3. Plățile PayPo sunt securizate?",
            text: "Da, toate plățile sunt procesate ca parte a unei conexiuni criptate. PayPo nu va solicita dete cu privire la contul tău bancar.",
        },
        {
            id: "4",
            title: "4. Utilizarea serviciilor PayPo costă?",
            text: "Nu. Utilizând plățile PayPo în termen de 30 de zile, vei plăti doar valoarea aferentă comenzii - fără taxe suplimentare.",
        },
        {
            id: "5",
            title: "5. Ce se întâmplă dacă nu plătesc în termen 30 de zile?",
            text: "Nu îți face griji, îți vom reaminti printr-un e-mail când se apropie data de rambursare, cu 3 zile înainte de expirarea termenului de plată.",
        },
        {
            id: "6",
            title: "6. Ce se întâmplă dacă returnez comanda?",
            text: "Pur și simplu nu vei plăti produsele returnate. Tranzacția va fi anulată în sistemul nostru.",
        },
    ],
    squares: [
        {
            top: "54rem",
            left: "13rem",
            size: "6rem",
            bgColor: colors.fuchsia500,
            rotate: "78.54deg",
        },
        {
            top: "6rem",
            right: "10rem",
            size: "10rem",
            bgColor: colors.fuchsia500,
            rotate: "20.46deg",
        },
        {
            top: "-6rem",
            right: "-13rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
        },
    ],
};

export const START_INLINE_TILES_CONFIG = {
    title: "Alătură-te",
    description: "Plățile noastre amânte sunt utilizate de 1 000 000 de clienți în Polonia, care finalizează cumpărăturile în cele mai populare magazine. Vezi ce spun clienții despre confortul și securitatea cumpărăturilor cu PayPo.",
    id: "section-opinions",
    forwardedRef: opinionsRef.forwardedRef,
    navigationRef: opinionsRef.navigationRef,
    tileList: [
        {
            id: 1,
            score: '5.0',
            name: "Andreea",
            text: "A fost o revelație pentru mine, pot vedea și proba hainele sau încălțămintea înainte de a efectua plata, fără a bloca fondurile din contul meu. Recomand tuturor.",
        },
        {
            id: 2,
            score: '5.0',
            name: "Ana",
            text: "O modalitate foarte practică pentru a face cumparături, cumpăr azi, plătesc peste 30 de zile dacă în momentul respectiv îmi lipsesc fondurile necesare. Este chiar cea mai bună alegere.",
        },
        {
            id: 3,
            score: '5.0',
            name: "Alexandra",
            text: "Recomand. Cu usurință pot să îmi permit achiziții mai mari.  Pentru mine este o super opțiune.",
        },
    ],
};

export const START_BIG_TILES_CONFIG = {
    title: "Contact",
    id: "section-contact",
    forwardedRef: contactRef.forwardedRef,
    navigationRef: contactRef.navigationRef,
    tileList: [
        {
            id: 1,
            bgColor: colors.mintCream,
            content: {
                title: [
                    "Tel.: 0312 294 746",
                    "E-mail: info@paypo.ro",
                ],
                textContent: [
                    {
                        id: 1,
                        text: "Serviciul Relații cu clienții este disponibil de luni până vineri între orele 08:00-18:00",
                    },
                ],
            },
        },
        {
            id: 2,
            bgColor: colors.palePurple,
            content: {
                title: "PayPo Plăți Amânate IFN S.A.",
                textContent: [
                    {
                        id: 1,
                        text: "Adresa: Str. Colței, nr. 8, etaj 4, sector 3, București",
                    },
                    {
                        id: 2,
                        text: "Nr. Registrul Comerțului București: J40/19544/2021",
                    },
                    {
                        id: 3,
                        text: "Cod Unic de Înregistrare: 45199303",
                    },
                    {
                        id: 4,
                        text: "Nr. Registrul General al BNR: RG-PJR-41-110375",
                    },
                ],
            },
        },
    ],
    squares: [
        {
            bottom: "5rem",
            left: "-9rem",
            size: "13.4rem",
            bgColor: colors.fuchsia500,
            rotate: "69.24deg",
        },
        {
            top: "6rem",
            right: "-10rem",
            size: "16.1rem",
            bgColor: colors.yellow500,
            rotate: "20.46deg",
        },
    ],
};

export const COOKIE_MODAL_CONFIG = {
    title: "Acest site folosește cookie-uri",
    description: "PayPo Plăți Amânate IFN S.A împreună cu partenerii noștri, folosim cookie-uri pentru a asigura funcționarea corectă a site-ului, pentru a adapta conținutul la preferințele dumneavoastră și pentru a urmări statisticile. Puteți fi de acord cu toate cookie-urile sau puteți utiliza site-ul nostru web numai cu cele care sunt necesare pentru funcționarea corectă a site-ului. Informații detaliate pot fi găsite în",
    link: {
        text: "Politica de confidențialitate și cookies",
        href: "https://static.paypo.ro/documents/Politica_de_confidentialitate_si_cookies.pdf",
    },
};
